import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=4748ff9b&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=4748ff9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748ff9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4748ff9b')) {
      api.createRecord('4748ff9b', component.options)
    } else {
      api.reload('4748ff9b', component.options)
    }
    module.hot.accept("./LanguageSelector.vue?vue&type=template&id=4748ff9b&scoped=true", function () {
      api.rerender('4748ff9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/LanguageSelector.vue"
export default component.exports